import React from 'react';
import { PlanVersion } from '../../types/commission';
import { Td, Th } from '../sf/DataTable';
import { StatusBadge } from '../sf/StatusBadge';
export function VersionHistoryTable({
  versions
}: {
  versions: PlanVersion[];
}) {
  return <div className="overflow-hidden rounded border border-sf-border" data-id="element-223" data-mp="z0pll2d3csx1">
      <table className="w-full border-collapse" data-id="element-224" data-mp="13zacucad829c">
        <thead data-id="element-225" data-mp="13xz92cgx6ui8">
          <tr data-id="element-226" data-mp="q0u7ops5ijtb">
            <Th data-id="element-227" data-mp="q0194c3cj0m9">Version</Th>
            <Th data-id="element-228" data-mp="pzrkaru1ezi5">Status</Th>
            <Th data-id="element-229" data-mp="q2nhuf1z3m62">Effective Start</Th>
            <Th data-id="element-230" data-mp="v06sz63djits">Effective End</Th>
            <Th data-id="element-231" data-mp="v0f68z3esq5i">Activated By</Th>
            <Th align="right" data-id="element-232" data-mp="uxav1hrj0u5c">Rules</Th>
          </tr>
        </thead>
        <tbody data-id="element-233" data-mp="g3xwgcavbjl2">
          {[...versions].reverse().map(version => <tr key={version.version} data-id="element-234" data-mp="l0ocx0ql4h70">
              <Td className="font-semibold" data-id="element-235" data-mp="l1pyhz588m2z">{version.label}</Td>
              <Td data-id="element-236" data-mp="2ahh1e778a4ge">
                <StatusBadge status={version.status} data-id="element-237" data-mp="2agxioo9r7c1b" />
              </Td>
              <Td data-id="element-238" data-mp="2ffqzapkc7j5p">{version.effectiveStartLabel}</Td>
              <Td data-id="element-239" data-mp="2fdef05r3wwph">{version.effectiveEndLabel}</Td>
              <Td className="text-sf-weak" data-id="element-240" data-mp="18g8qmorwj8dj">{version.activatedBy}</Td>
              <Td align="right" data-id="element-241" data-mp="13hxgse1lwxvb">{version.rules.length}</Td>
            </tr>)}
        </tbody>
      </table>
    </div>;
}